var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 36 40",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.68421 20c0-7.9529 6.40939-14.4 14.31579-14.4m-14.31579 14.4-2.68421-2.7m2.68421 2.7 3.13158-2.25m25.50001 2.25c0 7.9529-6.4094 14.4-14.3158 14.4m14.3158-14.4 2.6842 2.7m-2.6842-2.7-3.1316 2.25m-2.2368-16.65c0 1.98823-1.6024 3.6-3.579 3.6s-3.5789-1.61177-3.5789-3.6 1.6023-3.6 3.5789-3.6 3.579 1.61177 3.579 3.6zm-10.7369 28.8c0 1.9882-1.6023 3.6-3.5789 3.6s-3.57897-1.6118-3.57897-3.6 1.60237-3.6 3.57897-3.6 3.5789 1.6118 3.5789 3.6z",
    stroke: "#e830fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9474 5.6c0 1.98823-1.6023 3.6-3.5789 3.6s-3.5789-1.61177-3.5789-3.6 1.6023-3.6 3.5789-3.6 3.5789 1.61177 3.5789 3.6z",
    fill: "#e830fb",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.1579 34.6c0 1.9882-1.6024 3.6-3.579 3.6-1.9765 0-3.5789-1.6118-3.5789-3.6s1.6024-3.6 3.5789-3.6c1.9766 0 3.579 1.6118 3.579 3.6z",
    fill: "#e830fb",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.6364 12-1.2728 5.8182h7.6364l-7.6364 10.1818 1.2728-5.8182h-7.6364z",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstant);
export default __webpack_public_path__ + "static/media/Icon-Instant.1d301d7410971686c0604d30087fff8a.svg";
export { ForwardRef as ReactComponent };